import { Box, Tooltip, TextField, CircularProgress } from '@mui/material';
import { useState, FC, useEffect, useCallback } from 'react';
import styles from 'pages/projects/Projects.module.css';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { fetchProjects, fetchProjectsDownload } from 'entities/projects/actions/fetch-projects';
import { CurrentPageProjects, DownloadProjects, ErrorDownloadProjects, ErrorProjects, FileData, FileName, LoadingProjects, Projetcs } from 'entities/projects/selector';
import appStyles from 'app/providers/theme/App.module.css';
import Loader from 'shared/loader/Loader';
import { AlertMessage } from 'shared/alert-message/alert-message';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import List from 'widgets/list/list';
import ModalWidget from 'widgets/modal/Modal';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import TransferList from 'widgets/field-settings/FieldSettings';
import CustomButton from 'shared/custom-button/CustomButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { resetFileData, setCurrentPage } from 'entities/projects';
import { IProjects } from 'entities/projects/types/projects-interface';
import { allFields, defaultFields, fieldMappings } from 'features/projects/utils/constant';

interface IAlertInfo {
    message?: string;
    severity?: string;
}
export const Projects: FC = () => {
    const dispatch = useAppDispatch();
    const projectsList = useAppSelector(Projetcs);
    const currentPageProjects = useAppSelector(CurrentPageProjects);
    const isLoadingProjectsList = useAppSelector(LoadingProjects);
    const errorsProjectsList = useAppSelector(ErrorProjects);

    const [alertInfo, setAlertInfo] = useState<IAlertInfo>({ message: '', severity: '' });
    const [openSearch, setOpenSearch] = useState(false);

    const [searchQuery, setSearchQuery] = useState<string>('');

    const handleOpenSearch = () => setOpenSearch((prevState) => !prevState);

    useEffect(() => {
        dispatch(fetchProjects())
    }, [])


    const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        dispatch(setCurrentPage({ page: 1 }));
    }, [dispatch]);

    const handleChildAction = useCallback((page: number) => {
        dispatch(setCurrentPage({ page }));
    }, [dispatch]);

    const filteredData = projectsList.filter((item: IProjects) => {
        const matchesSearchQuery =
            item.Number.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.InsurancePremium.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.PaymentStatusName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.ProductName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.StartDate.toLowerCase().includes(searchQuery.toLowerCase());

        return matchesSearchQuery;
    });


    const paginatedData = () => {
        const startIndex = (currentPageProjects - 1) * 10;
        return filteredData.slice(startIndex, startIndex + 10);
    };

    const [openSetting, setOpenSetting] = useState(false);

    const [fields, setFields] = useState<string[]>(defaultFields);
    const [tempFields, setTempFields] = useState<string[]>(fields);

    const handleOpenSetting = () => {
        setTempFields(fields);
        setOpenSetting(true);
    };

    const handleCloseSetting = () => {
        setOpenSetting(false);
    };
    const handleResetSetting = () => {
        setTempFields(defaultFields);
    };
    const handleAcceptSetting = () => {
        setFields(tempFields);
        setOpenSetting(false);
    };

    const handleTempFieldsChange = (newFields: string[]) => {
        setTempFields(newFields);
    };
    const renderItem = (item: any) => (
        <>
            {fields.map((field) => {
                const key = fieldMappings[field];
                if (key === 'CommissionSum') {
                    return (
                        <Box key={field}>
                            {item.CommissionSum ? (
                                <p>{item.CommissionSum} <span className={styles.icon}><CurrencyRubleIcon /></span></p>
                            ) : (
                                <p>-</p>
                            )}
                        </Box>
                    );
                } else if (key === 'CommissionPercent') {
                    return (
                        <Box key={field}>
                            {item.CommissionPercent ? (
                                <p>{item.CommissionPercent} <span className={styles.icon}>%</span></p>
                            ) : (
                                <p>-</p>
                            )}
                        </Box>
                    );
                } else if (key === 'InsuranceSum') {
                    return (
                        <Box key={field}>
                            <p>{item.InsuranceSum} <span className={styles.icon}><CurrencyRubleIcon /></span></p>
                        </Box>
                    );
                } else if (key === 'InsurancePremium') {
                    return (
                        <Box key={field}>
                            <p>{item.InsurancePremium} <span className={styles.icon}><CurrencyRubleIcon /></span></p>
                        </Box>
                    );
                } else {
                    return (
                        <Box key={field}>
                            <p>{item[key]}</p>
                        </Box>
                    );
                }
            })}
        </>
    );
    const isDowloadProjects = useAppSelector(DownloadProjects);
    const errorDowloadProjects = useAppSelector(ErrorDownloadProjects);
    const fileNameProjects = useAppSelector(FileName);
    const fileDataProjects = useAppSelector(FileData);
    const [downloadTriggered, setDownloadTriggered] = useState(false);

    const handleFileDownload = async () => {
        setAlertInfo({ message: '', severity: '' });

        try {
            await dispatch(fetchProjectsDownload());

            setDownloadTriggered(true);
        } catch (error) {
            console.error('Error downloading the file:', error);
        } 
    };

    useEffect(() => {
        if (downloadTriggered && fileDataProjects && errorDowloadProjects.length === 0) {
            const link = document.createElement('a');
            link.href = `data:application/octet-stream;base64,${fileDataProjects}`;
            link.download = fileNameProjects;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dispatch(resetFileData());
            setDownloadTriggered(false);
        } else if (errorDowloadProjects.length > 0) {
            setAlertInfo({ message: errorDowloadProjects[0].Msg, severity: 'error' });
            const timeoutId = setTimeout(() => {
                setAlertInfo({ message: '', severity: '' });
                dispatch(resetFileData());
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [downloadTriggered, fileDataProjects, errorDowloadProjects, fileNameProjects, dispatch]);

    return (
        <>
            <Box className={appStyles.titleBox}>
                <h1>Договоры без конверсии</h1>
            </Box>
            {isLoadingProjectsList && (
                <Loader
                    title='Подготовка списка. Это займет несколько секунд.'
                />
            )}
            {!isLoadingProjectsList && (
                <>
                    {alertInfo.message && (
                        <Box className={appStyles.alertBox}>
                            <AlertMessage alertInfo={alertInfo} />
                        </Box>
                    )}

                    {projectsList.length > 0 && (
                        <Box className={styles.btnContainer}>
                            {isDowloadProjects ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : (
                                <Tooltip title="Выгрузить в Excel" placement="top">
                                    <Box>
                                        <CustomButton
                                            icon={FileDownloadIcon}
                                            handleClick={handleFileDownload}
                                            textColor='white'
                                            backgroundColor="#0054E6"
                                            border='none'
                                            borderRadius='4px'
                                            padding="8px 30px"
                                            disabled={false}
                                        />
                                    </Box>
                                </Tooltip>
                            )}
                        </Box>
                    )}
                    <Box className={appStyles.iconSort}>
                        <span
                            onClick={() => handleOpenSetting()}
                        >
                            <SettingsIcon />
                        </span>
                        <span onClick={handleOpenSearch} className={`${openSearch ? appStyles.iconSelected : ''}`}><SearchIcon /></span>
                    </Box>
                    {openSearch && (
                        <TextField
                            label="Поиск"
                            variant="outlined"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            fullWidth
                            margin="normal"
                        />
                    )}
                    <ModalWidget
                        open={openSetting}
                        handleClose={handleCloseSetting}
                        title="Настройка полей таблицы"
                        closeIconPosition="right"
                        showAcceptButton
                        showCancelButton
                        onAccept={handleAcceptSetting}
                        onCancel={handleResetSetting}
                        widthProps={650}
                    >
                        <TransferList
                            key={JSON.stringify(tempFields)}
                            defaultFields={tempFields}
                            allFields={allFields}
                            onFieldsChange={handleTempFieldsChange}
                        />
                    </ModalWidget>

                    {projectsList.length > 0 && filteredData.length > 0 ? (
                        <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>

                            <List
                                title={fields}
                                data={paginatedData()}
                                renderItem={renderItem}
                                renderPagination={filteredData.length > 10}
                                pageCount={Math.ceil(filteredData.length / 10)}
                                onAction={handleChildAction}
                                currentPage={currentPageProjects}
                                link={false}
                            />
                        </Box>
                    ) : (
                        <Box className={appStyles.infoBox}>
                            <p>Договоры не найдены</p>
                        </Box>
                    )}
                </>
            )}
        </>
    );
};

export default Projects;
